const assets = (state) => state.assets;

export default assets;
